import { createFileRoute, redirect } from '@tanstack/react-router'

import { movedToConsole } from '@/features/auth/require-session'

/** The Watches' old address: the console's for the operator, the evaluations for anyone else. */
export const Route = createFileRoute('/_app/watches')({
  beforeLoad: ({ context }) =>
    movedToConsole(context.queryClient, () => redirect({ to: '/platform/watches', replace: true })),
})
